import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getNewsShowById, getNewsShows } from "./action";

export const newsShowsEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.showId || entity.id,
});

const initialState = newsShowsEntityAdapter.getInitialState({
  totalCount: 0,
  modals: { newsShowsAddModal: null, newsShowsDeleteModal: null },
  error: null,
});

export const newsShowsSlice = createSlice({
  name: "newsShows",
  initialState,
  reducers: {
    showNewsShowsAddModal: (state, action) => {
      state.modals.newsShowsAddModal = action.payload;
    },
    showNewsShowsDeleteModal: (state, action) => {
      state.modals.newsShowsDeleteModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNewsShows.fulfilled, (state, action) => {
      if (action.payload.statusCode === 200) {
        if (action.payload.entities?.show) {
          newsShowsEntityAdapter.setAll(state, Object.values(action.payload.entities.show));
          state.totalCount = action.payload.data.totalItems || 0;
        } else if (action.payload.items?.length) {
          newsShowsEntityAdapter.setAll(state, action.payload.items);
          state.totalCount = action.payload.totalItems || action.payload.items.length || 0;
        } else {
          state.ids = [];
          state.totalCount = 0;
        }
      }
    });

    builder.addCase(getNewsShowById.fulfilled, (state, action) => {
      if (action.payload.statusCode === 200) {
        newsShowsEntityAdapter.setOne(state, action.payload.data);
      }
    });
  },
});

export const { showNewsShowsAddModal, showNewsShowsDeleteModal } = newsShowsSlice.actions;
export default newsShowsSlice.reducer;
